import { render, staticRenderFns } from "./StackItem.vue?vue&type=template&id=4a2b7bfc&scoped=true&lang=pug&"
import script from "./StackItem.vue?vue&type=script&lang=js&"
export * from "./StackItem.vue?vue&type=script&lang=js&"
import style0 from "./StackItem.vue?vue&type=style&index=0&id=4a2b7bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b7bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2b7bfc')) {
      api.createRecord('4a2b7bfc', component.options)
    } else {
      api.reload('4a2b7bfc', component.options)
    }
    module.hot.accept("./StackItem.vue?vue&type=template&id=4a2b7bfc&scoped=true&lang=pug&", function () {
      api.rerender('4a2b7bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/StackItem.vue"
export default component.exports